export const ALL_RELEASE_TOGGLE_NAMES = [
  "REPORT_LANGUAGE_141",
  "IMPROVED_LIST_STYLE",
  "DO_UPLOADS_INITIATED_192",
  "GENERATE_PATIENT_STATUS_COMMENTS_227",
  "GENERATE_FINDINGS_233",
  "GENERATE_DIAGNOSIS_246",
  "FINDINGS_GENERATOR_VALUES_OUTDATED_247",
  "ADD_LESS_THAN_0_1_RULES_268",
  "VENTRICULAR_TACHYCARDIA_FINDINGS_FIELD_267",
  "UPLOAD_FORM_TEXT_AREAS_AUTO_EXPANDING_263",
  "ADD_NEW_ATRIAL_TACHYCARDIAS_RULES_269",
  "PATIENT_ID_MUST_NOT_CONTAIN_SSN_241",
  "TRIM_SPACES_ON_PASSWORD_CHANGE_265",
  "FORMAT_FINDINGS_VALUES_271",
  "NURSE_DELETES_INITIATED_MEASUREMENT_277",
  "EDIT_HOLTER_TYPE_16",
  "REASSIGN_DOCTOR_276",
  "SHOW_SYMPTOM_CHARACTER_COUNTER_TO_NURSES_297",
  "PUT_HOSPITAL_IN_CHAIN_280",
  "E_FORM_LANGUAGE_SELECTOR_303",
  "NEW_E_FORM_LANDING_PAGE_DESIGN_304",
  "ASSIGN_TO_CHAIN_282",
  "UPDATE_RULES_333",
  "HOME_HOLTER_PILOT_340",
  "HOME_HOLTER_LENGTH_342",
  "ENABLE_HOME_MEASUREMENT_TYPES_311",
  "HOME_MEASUREMENT_E_FORM_315",
  "ORDER_HOME_MEASUREMENT_367",
  "ORDERED_STATUS_IN_NURSE_LIST_370",
  "COPY_HOME_MEASUREMENT_INSTRUCTIONS_373",
  "DOWNLOAD_HOME_MEASUREMENT_INSTRUCTIONS_395",
  "HOME_STATUS_FOR_NURSE_AND_DO_319",
  "HIDE_UPLOAD_INITIATE_DATA_FORMS_WHEN_NO_LOCAL_TYPES_ALLOWED_368",
  "SKIP_REPORT_411",
  "E-FORM_CODE_IN_URL_397",
  "USER_RESETS_PASSWORD_359",
  "OTP_EXPIRY_COUNTDOWN_218",
  "REPEAT_MEASUREMENT_379",
  "REVERT_FROM_DONE_18",
  "HMO_CAN_COMMENT_419",
  "ASSIGN_EITHER_TECHNICIAN_OR_DOCTOR_428",
  "DISPLAY_SAMPLES_REPORT_IN_ANALYSIS_PAGE_435",
  "INITIATE_MEASUREMENT_API_432",
  "DEVICE_SERIAL_IN_NURSE_LIST_438",
  "INITIATE_WITH_DEVICE_SERIAL_439",
  "REPEAT_HOME_MEASUREMENT_BEFORE_UPLOAD_453",
  "REVERT_FROM_DONE_AFTER_NURSE_DOWNLOADS_REPORT_457",
  "PRE_ANALYZE_ECG_MEASUREMENTS_459",
  "BASIC_ECG_PATIENT_DATA_467",
  "BASIC_ECG_DATA_IN_REPORT_WHEN_DOCTOR_ANALYSIS_SKIPPED_468",
  "GLOBAL_TECHNICIAN_POOL_481",
  "ASSIGN_GLOBAL_TECHNICIAN_POOL_AS_DOCTOR_485",
  "ASSIGN_GLOBAL_TECHNICIAN_POOL_FOR_PREANALYSIS_484",
  "DOCTOR_SEES_ECG_DATA_ENTERED_BY_TECHNICIAN_497",
  "TECHNICIAN_ADDS_ADDITIONAL_PQ_INTERVALS_505",
  "WARN_DOCTOR_WHEN_OPENING_ANALYSIS_THAT_IS_BEING_ANALYSED_290",
  "DOWNLOAD_FINDINGS_FOR_PREANALYSED_MEASUREMENT_507",
  "LET_DOCTOR_OPEN_ECG_REPORT_IN_NEW_TAB_509",
  "REFRESH_SAMPLES_REPORT_513",
  "COMBINE_ECG_SYMPTOM_COMMENTS_INTO_ONE_521",
  "SYMPTOM_DIARY_IN_PATIENT_DATA_524",
  "MEASUREMENT_DETAILS_ON_MAIL_DEVICE_PAGE_514",
  "REASON_FOR_STUDY_AF_OPTION_523",
  "REJECT_MEASUREMENT_IN_MEASUREMENT_DETAILS_516",
  "REJECT_INITIATED_HOME_MEASUREMENT_515",
  "MODIFY_REPORT_GENERATOR_SENTENCES_533",
  "MODIFY_REPORT_GENERATION_LOGIC_532",
  "HIDE_ITEMS_IN_REPORT_TOOL_BASED_ON_MEASUREMENT_TYPE_535",
  "HEIGHT_AND_WEIGHT_NOT_MANDATORY_FOR_ECG_464",
  "DESCRIPTIONS_FOR_FIELDS_IN_REPORT_TOOL_551",
  "REASSIGN_TECHNICIAN_547",
  "REPEAT_MEASUREMENT_AT_ADDITIONAL_STATUSES_546",
  "SHOW_MEASUREMENTS_TO_GLOBAL_TECHNICIAN_AFTER_ANALYSIS_541",
  "SHOW_E_FORM_CODE_ON_HMO_LIST_581",
  "ADD_NURSES_WITH_SET_LANGUAGE_447",
  "AUTOMATICALLY_GENERATE_SLEEP_REPORT_569",
  "DATE_OF_BIRTH_PICKER_STARTS_ON_YEAR_601",
  "DATA_OFFICER_RELEASES_FEATURES_609",
  "DOCTOR_ANALYSES_SLEEP_573",
  "EDIT_PATIENT_DATA_DURING_PROCESSING_614",
  "REPEAT_TECHNICIAN_ANALYSIS_616",
  "DEPRECATION_WARNING_FOR_OLD_UPLOAD_FLOW_621",
] as const;
type ReleaseToggleNameTuple = typeof ALL_RELEASE_TOGGLE_NAMES;
export type ReleaseToggleName = ReleaseToggleNameTuple[number];

export interface ReleaseToggle {
  name: ReleaseToggleName;
  released: boolean;
}

export class ReleaseToggleState {

  private static instance: ReleaseToggleState | undefined = undefined;

  public static getInstance(): ReleaseToggleState {
    if (ReleaseToggleState.instance === undefined) {
      ReleaseToggleState.instance = new ReleaseToggleState();
    }

    return ReleaseToggleState.instance;
  }

  private readonly toggles: Map<ReleaseToggleName, boolean> = new Map();

  public setToggles(toggles: ReleaseToggle[]) {
    this.toggles.clear();
    toggles.forEach(toggle => this.toggles.set(toggle.name, toggle.released));
  }

  public enableAllToggles() {
    this.toggles.clear();
    ALL_RELEASE_TOGGLE_NAMES.forEach(toggle => this.toggles.set(toggle, true));
  }

  public isReleased(name: ReleaseToggleName): boolean {
    return this.toggles.get(name) || false;
  }

  public turnOff(name: ReleaseToggleName) {
    this.toggles.set(name, false);
  }

  public select<T>(name: ReleaseToggleName, valueIfReleased: T, valueIfNotReleased: T): T {
    return this.isReleased(name)
      ? valueIfReleased
      : valueIfNotReleased;
  }
}
